import type { ReactNode } from 'react';
import Attribute, { Props as AttributeProps } from './_Attribute';
import type { ComparisonProduct } from './types';

export interface Props {
  sectionTitle: string;
  attributes?: Array<AttributeProps>;
  selectedSkus: Array<string>;
  products: Array<ComparisonProduct>;
  asContentRow?: boolean;
  renderTooltip?: (text: string) => ReactNode;
}

const Section = ({
  sectionTitle,
  attributes,
  selectedSkus,
  products,
  asContentRow,
  renderTooltip,
}: Props) => {
  return (
    <div className="bg-white">
      {sectionTitle && (
        <table className="w-full grid">
          <thead className="bg-warm-100 py-3 w-full">
            <tr>
              <th scope="col" colSpan={2}>
                <h5 className="tra-text-web-heading-6 sticky left-0 pl-6 inline-block">
                  {sectionTitle}
                </h5>
              </th>
            </tr>
          </thead>
          <tbody>
            {attributes?.map(
              ({ attribute, shortDescription, salesforceField, commerceField }, idx) => (
                <Attribute
                  key={idx}
                  attribute={attribute}
                  shortDescription={shortDescription}
                  salesforceField={salesforceField}
                  commerceField={commerceField}
                  selectedSkus={selectedSkus}
                  products={products}
                  asContentRow={asContentRow}
                  renderTooltip={renderTooltip}
                />
              ),
            )}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default Section;
